export const WIDGET_ID = '2fee3364-0407-4de0-b186-832be61142b6';
export const APP_DEFINITION_ID = '5e762334-899c-4e32-a7ad-b80f03471dfb';
